import { Dialog, IconButton, TableRow } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const AddLineContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
`;

export const PublicationDateContainer = styled.h1`
  margin-left: 7.5rem;
  font-size: 0.95rem;
  padding: 1.5rem 0rem;
`;

export const PublicationDateLabel = styled.span`
  font-weight: 600;
  padding-right: 1rem;
`;

export const StyledDialog = styled(Dialog)<{ align?: string }>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 600px;
    max-width: 100%;

    && .MuiTextField-root {
      width: 100%;
      padding: 5rem;
    }
  }
  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;

export const StyledIconButton = styled(IconButton)`
  height: 30px;
  width: 30px;
  &&:hover {
    color: ${COLORS.BLUE};
  }
`;

export const LinesTableRow = styled(TableRow)<{
  $marked?: boolean;
}>`
  ${({ $marked }) =>
    $marked &&
    `{
    background-color: #ffe02d;
    &&.MuiTableRow-hover:not(.Mui-selected) {
      &:hover {
        background-color: #f1d63e;
      }
    }
    }`}
`;
